import React from 'react';
import t from '@jetshop/intl';
import Styled from './Style';
import Price from '../../../components/Price';
import { styled } from 'linaria/react';
import { theme } from '../../../components/Theme';
import useCheckChannelCountry from '../../../hooks/useCheckChannelCountry';

const PreviousPriceContainer = styled('div')`
  display: flex;
  flex-direction: column;
  color: ${theme.colorScheme.mediumgrey};
  margin-bottom: 10px;
`;

const PriceContainer = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const ProductPrice = ({
  price: {
    price,
    previousPrice,
    latestPrice,
    hasDiscount,
    formattedPricing,
    currencyLocale
  }
}) => {
  const recommendedPrice = previousPrice;

  const showPreviousPrice =
    hasDiscount &&
    latestPrice?.incVat !== recommendedPrice?.incVat &&
    latestPrice?.incVat !== price?.incVat;

  const { isSE } = useCheckChannelCountry();
  return (
    <Styled.ProductPriceWrapper>
      {hasDiscount ? (
        <>
          <Styled.DiscountPrice>
            <Price
              countryCode={currencyLocale?.culture}
              price={price?.incVat && Number(price?.incVat)}
            >
              {formattedPricing?.price}
            </Price>
          </Styled.DiscountPrice>
          <Styled.VAT>{t('inc. VAT')}</Styled.VAT>
          {isSE ? (
            <PreviousPriceContainer>
              {showPreviousPrice && (
                <PriceContainer>
                  {t('Previous price: ')}
                  <Styled.OriginalPrice>
                    <Price
                      countryCode={currencyLocale?.culture}
                      price={latestPrice?.incVat && Number(latestPrice.incVat)}
                    >
                      {formattedPricing?.previousPrice}
                    </Price>
                  </Styled.OriginalPrice>
                </PriceContainer>
              )}
              {hasDiscount && (
                <PriceContainer>
                  {t('Rec. price: ')}

                  <Price
                    countryCode={currencyLocale?.culture}
                    price={
                      previousPrice?.incVat && Number(previousPrice.incVat)
                    }
                  >
                    {formattedPricing?.previousPrice}
                  </Price>
                </PriceContainer>
              )}
            </PreviousPriceContainer>
          ) : (
            <PreviousPriceContainer>
              <PriceContainer>
                <Price
                  countryCode={currencyLocale?.culture}
                  decoration="line-through"
                  price={previousPrice?.incVat && Number(previousPrice?.incVat)}
                >
                  {formattedPricing?.previousPrice}
                </Price>
              </PriceContainer>
            </PreviousPriceContainer>
          )}
        </>
      ) : (
        <>
          <Styled.NormalPrice>
            <Price
              countryCode={currencyLocale?.culture}
              price={price?.incVat && Number(price?.incVat)}
            >
              {formattedPricing?.price}
            </Price>
          </Styled.NormalPrice>
          <Styled.VAT>{t('inc. VAT')}</Styled.VAT>
        </>
      )}
    </Styled.ProductPriceWrapper>
  );
};

export default ProductPrice;
